import {Injectable, Inject} from 'ng-metadata/core';

@Injectable()
export class PartiallyTranslatedLocalFieldsUtil {

    constructor(
                @Inject('$q') private $q: ng.IQService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService)
                {
    }

    public handlePartiallyTranslatedLocalFacet(facet, useTranslation : Boolean) : Promise<string>{
        return this.$q((resolve, reject) => {
            if(!facet){
                reject();
            }
            if(useTranslation){
                this.parsePartiallyTranslatedLocalField(facet.value).then((parsedVal) => {
                    facet.tooltip = this.$translate.instant('nui.facets.remove.tooltip') + this.$translate.instant('fulldisplay.' + facet.name) + ' ' + parsedVal;
                    resolve(parsedVal);
                })
            } else {
                resolve(this.removeTranslationTags(facet.value));
            }
        })
    }

    public parsePartiallyTranslatedLocalField(value) : Promise<string> {
		return this.$q((resolve, reject) => {
			if (!value){
                reject();
			}
			let valueArr = value.split('$$');
			let shifted = valueArr.shift();
			let codesArray= valueArr.filter((s)=>{return s.charAt(0) === 'T'}).map((s)=>{return s.slice(1).trim().toLowerCase()});
			this.$translate(codesArray).then((translations)=>{
				valueArr = valueArr.map((s)=>{
					if(s.charAt(0) === 'T'){
                        return translations[s.slice(1).trim().toLowerCase()] === s.slice(1).trim().toLowerCase() ?
                                s.slice(1).trim() :
                                translations[s.slice(1).trim().toLowerCase()];
					} else {
						return s.trim();
					}
				});
				valueArr.unshift(shifted);
				resolve(valueArr.join(' '));
			});
		})
    }
    
    public removeTranslationTags(value : string) : string {
        if(value){
            return value.replace(/\$\$T/g, '').replace(/ \$\$/g, '').replace(/\$\$/g, '');
        }
        return value;
    }

    public isPartiallyTranslated(value : string) : Boolean {
        if(value){
            return value.indexOf("$$T") > -1;
        }
        return false;
    }
}




// WEBPACK FOOTER //
// ./src/main/webapp/components/nddUtils/partiallyTranslatedLocalFieldsUtil.service.ts